// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/topNav/TopNav.scss
// module id = 2356
// module chunks = 0